import axios from 'axios'
import OptionsTransformer from 'transformers/OptionsTransformer'
import ServiceTestByLocationTransformer from 'transformers/ServiceTestByLocationTransformer'
import AncillaryServiceGroupTransformer from 'transformers/AncillaryServiceGroupTransformer'

export default {
    getList(fields) {
        const _fields = (fields || ['id', 'name', 'category(id,name)']).join(',')

        return axios.get('facility-services', {
            params: { _fields },
            transformResponse: [OptionsTransformer.transform('id', 'name')],
        })
    },

    getFacilityServiceGroups(query, fields) {
        const _fields = (fields || ['id', 'name', 'facilityServiceTypes(id,name)']).join(',')
        const params = {
            _fields,
            ...query,
        }
        return axios.get('facility-service-groups', { params })
    },

    getFacilityServiceGroupsTransform(query, fields) {
        const _fields = (fields || ['id', 'name', 'facilityServiceTypes(id,name)']).join(',')
        const params = {
            _fields,
            ...query,
        }
        return axios.get('facility-service-groups', {
            params,
            transformResponse: [AncillaryServiceGroupTransformer.transform('id', 'name')],
        })
    },

    createFacilityServiceTypes(id, data) {
        return axios.post(`/facility-service-types/practices/${id}`, data)
    },

    updateFacilaryServiceTypes(id, data) {
        return axios.post(`/facility-service-types/practices/${id}`, data)
    },

    getFacilityServiceSubGroups(id) {
        return axios.get(`/facility-service-tests/${id}`)
    },

    updateFacilityServiceTests(id, serviceId, data) {
        return axios.post(`/facility-service-tests/practices/${id}/services/${serviceId}`, data)
    },

    getServiceTests(practiceId, serviceId) {
        return axios.get(`/facility-service-tests/practices/${practiceId}/services/${serviceId}`, {
            transformResponse: [ServiceTestByLocationTransformer.transform()],
        })
    },

    getFacilityServiceTestSearch(query) {
        const params = {
            ...query,
        }
        return axios.get(`/facility-service-tests/search`, { params })
    },

    getMatchesList(data, fields) {
        const _fields = (
            fields || [
                'id',
                'name',
                'image',
                'referralsReceivedCount',
                'connectionCount',
                'rating',
                'locations(id,name,address,city,state,zip,coordinates,isAvailabilitySet)',
                'facilityServiceTypes(id,name,groupId,facilityServiceTests(id,name,serviceId,practiceFacilityServiceTests(practiceLocationId))))',
            ]
        ).join(',')
        return axios.get('/referrals/ancillary-matches', {
            params: { _fields, ...data },
        })
    },

    getAncillaryServicesByLocation(practiceId) {
        return axios.get(`/facility-service-tests/practices/${practiceId}`)
    },
}
